import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import InlineSvg from 'components/ui/InlineSvg/InlineSvg'

import s from './Icons.scss'

import appleIcon from './images/apple.svg'
import bottomArrowSmallIcon from './images/bottom-arrow-small.svg'
import checkmarkIcon from './images/checkmark.svg'
import checkmarkInCircleIcon from './images/checkmark-in-circle.svg'
import checkmarkLongIcon from './images/checkmark-long.svg'
import closeIcon from './images/close.svg'
import closeBoldIcon from './images/closeBold.svg'
import creditCardIcon from './images/credit-card.svg'
import dislikeIcon from './images/dislike.svg'
import facebookIcon from './images/facebook.svg'
import googleIcon from './images/google.svg'
import heartIcon from './images/heart.svg'
import infoInCircleIcon from './images/info-in-circle.svg'
import leftArrowIcon from './images/left-arrow.svg'
import leftArrowSmallIcon from './images/left-arrow-small.svg'
import likeIcon from './images/like.svg'
import lockIcon from './images/lock.svg'
import paypalIcon from './images/paypal.svg'
import pencilIcon from './images/pencil.svg'
import playIcon from './images/play.svg'
import plusIcon from './images/plus.svg'
import minusIcon from './images/minus.svg'
import plusInCircleIcon from './images/plus-in-circle.svg'
import minusInCircleIcon from './images/minus-in-circle.svg'
import questionIcon from './images/question.svg'
import replayIcon from './images/replay.svg'
import rightArrowIcon from './images/right-arrow.svg'
import rightArrowSmallIcon from './images/right-arrow-small.svg'
import searchIcon from './images/search.svg'
import timesIcon from './images/times.svg'
import truckIcon from './images/truck.svg'
import eyeIcon from './images/eye.svg'
import historyIcon from './images/history.svg'
import garbageIcon from './images/garbage.svg'
import busIcon from './images/bus.svg'
import copyIcon from './images/copy.svg'
import calendarIcon from './images/calendar.svg'


export const icons = {
  garbage: garbageIcon,
  apple: appleIcon,
  bottomArrowSmall: bottomArrowSmallIcon,
  checkmark: checkmarkIcon,
  checkmarkInCircle: checkmarkInCircleIcon,
  checkmarkLong: checkmarkLongIcon,
  close: closeIcon,
  closeBold: closeBoldIcon,
  creditCard: creditCardIcon,
  dislike: dislikeIcon,
  facebook: facebookIcon,
  google: googleIcon,
  heart: heartIcon,
  infoInCircle: infoInCircleIcon,
  leftArrow: leftArrowIcon,
  leftArrowSmall: leftArrowSmallIcon,
  like: likeIcon,
  lock: lockIcon,
  paypal: paypalIcon,
  pencil: pencilIcon,
  play: playIcon,
  plusInCircle: plusInCircleIcon,
  minusInCircle: minusInCircleIcon,
  plus: plusIcon,
  minus: minusIcon,
  question: questionIcon,
  replay: replayIcon,
  rightArrow: rightArrowIcon,
  rightArrowSmall: rightArrowSmallIcon,
  search: searchIcon,
  times: timesIcon,
  truck: truckIcon,
  eye: eyeIcon,
  history: historyIcon,
  bus: busIcon,
  copy: copyIcon,
  calendar: calendarIcon,
}

// TODO update minus and plus to cross
const colors = [ 'black', 'brand', 'gray', 'green', 'yellow', 'red', 'white', 'greenLight', 'purple' ]
const sizes = [ 8, 12, 16, 20, 24, 32 ]


const Icons = ({ className, name, size: _size, color, disabled, onClick }) => {
  if (!icons[name]) {
    console.error(`There is no icon with name "${name}"`)
  }

  const size = ({
    md: 24,
    sm: 16,
    xs: 8,
  })[_size] || _size

  const rootClassName = cx(s[name], s.icon, className, {
    [s[`size_${size}`]]: size,
    [s[`color_${color}`]]: !disabled && color,
    [s.disabled]: disabled,
    [s.pointer]: Boolean(onClick && !disabled),
  })

  return (
    <span className={className} onClick={disabled ? null : onClick}>
      <InlineSvg
        className={rootClassName}
        src={icons[name]}
        cache
      />
    </span>
  )
}

Icons.propTypes = {
  name: PropTypes.oneOf(Object.keys(icons)).isRequired,
  color: PropTypes.oneOf(colors),
}


export default React.memo(Icons)
